import { render, staticRenderFns } from "./NoteCollapse.vue?vue&type=template&id=6b7c5850&scoped=true"
import script from "./NoteCollapse.vue?vue&type=script&lang=js"
export * from "./NoteCollapse.vue?vue&type=script&lang=js"
import style0 from "./NoteCollapse.vue?vue&type=style&index=0&id=6b7c5850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c5850",
  null
  
)

export default component.exports